import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const WorkPage = lazy(() => import('../pages/work/page'));
const PhotographyPage = lazy(() => import('../pages/photography/page'));
const FineArtPage = lazy(() => import('../pages/fine-art/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BluePrintsDodgersPage = lazy(() => import('../pages/projects/blue-prints-dodgers/page'));
const YaamavaActivationPage = lazy(() => import('../pages/projects/yaamava-activation/page'));
const SportsCampPage = lazy(() => import('../pages/projects/sports-camp/page'));
const WorkflowSolutionsPage = lazy(() => import('../pages/projects/workflow-solutions/page'));
const ProfessionalPhotographyPage = lazy(() => import('../pages/projects/professional-photography/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/work',
    element: <WorkPage />,
  },
  {
    path: '/photography',
    element: <PhotographyPage />,
  },
  {
    path: '/fine-art',
    element: <FineArtPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  // Project case study pages
  {
    path: '/projects/blue-prints-dodgers',
    element: <BluePrintsDodgersPage />,
  },
  {
    path: '/projects/yaamava-activation',
    element: <YaamavaActivationPage />,
  },
  {
    path: '/projects/sports-camp',
    element: <SportsCampPage />,
  },
  {
    path: '/projects/workflow-solutions',
    element: <WorkflowSolutionsPage />,
  },
  {
    path: '/projects/professional-photography',
    element: <ProfessionalPhotographyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
